import { createApp } from 'vue';

export function mountVueTool(component, elementId) {
    const mountElement = document.getElementById(elementId);

    if (!mountElement) {
        return null;
    }

    return createApp(component, {
        embedUrl: mountElement.dataset.embedUrl || '',
        embed: mountElement.dataset.embed === '1',
        preview: mountElement.dataset.preview === '1',
    }).mount(mountElement);
}
